import "./AboutUsCRCard.css";
import { FaHandshake } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import { FaCalendarAlt } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaBagShopping } from "react-icons/fa6";
import { FaMusic } from "react-icons/fa6";


export default function AboutUsCRCard({
  stepNumber = "04",
  title = "Discover & Book Venues",
  subtitle = "Find and book top venues across India",
  Icon = FaLocationDot,
}) {
  return (
    <div className="dbc-wrap">
      {/* Circular step badge */}
      <div className="dbc-badge">{stepNumber}</div>

      {/* Card */}
      <div className="about-us-inverted-radius">
        <div className="dbc-card-wrap">
        <div className="dbc-icon">
          {Icon === FaLocationDot && <FaLocationDot />}
          {Icon === FaHandshake && <FaHandshake />}
          {Icon === FaCalendarAlt && <FaCalendarAlt />}
          {Icon === FaUsers && <FaUsers />}
          {Icon === FaBagShopping && <FaBagShopping />}
          {Icon === FaMusic && <FaMusic />}
        </div>
        <h3 className="dbc-title">{title}</h3>
        <p className="dbc-subtitle">{subtitle}</p>
        </div>
      </div>
    </div>
  );
}

function PinIcon() {
  return (
    <svg
      className="dbc-pin"
      width="48"
      height="48"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22s6-6.326 6-11a6 6 0 1 0-12 0c0 4.674 6 11 6 11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="11" r="2.5" fill="currentColor" />
    </svg>
  );
}
